<template>
  <v-app>
    <navigation-drawer>
      <template #navigation>
        <default-layout-menu />
      </template>
      <template #header>
        <img v-if="$vuetify.display.mdAndDown" src="@/assets/img/logo-inline.svg" class="d-block" />
        <div v-else class="caption text-ordinary">Экстранет Алеан</div>
        <v-spacer />
        <default-layout-header />
      </template>
      <template #main>
        <slot />
      </template>
    </navigation-drawer>
  </v-app>
</template>

<script lang="ts" setup>
import NavigationDrawer from '@/core/layouts/components/NavigationDrawer.vue';
import DefaultLayoutHeader from '@/core/layouts/components/default/DefaultLayoutHeader.vue';
import DefaultLayoutMenu from '@/core/layouts/components/default/DefaultLayoutMenu.vue';
</script>
